import lazyload from 'lazyload'
document.addEventListener("DOMContentLoaded", function() {

  let images = document.querySelectorAll(".lazyload");
  new lazyload(images);

});